function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M114.3 109.2l-93.5 14.2c-3.7.6-7.1-2-7.7-5.7l-12-79.2c-.6-3.7 2-7.1 5.7-7.7l93.5-14.2c3.7-.6 7.1 2 7.7 5.7l12 79.2c.5 3.7-2 7.1-5.7 7.7z",
  fill: "#ededed"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M110.2 37.2L3.4 53.5l-2.3-15c-.6-3.7 2-7.1 5.7-7.7l93.5-14.2c3.7-.6 7.1 2 7.7 5.7l2.2 14.9z",
  fill: "#f7bdbd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.8 35.4l-2.7-17.7m34.4 12.9l-2.7-17.8",
  fill: "#ededed",
  stroke: "#ffd800",
  strokeWidth: 9.283,
  strokeLinecap: "round",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7 92.2c.2-2 .6-3.8 1.2-5.2.6-1.5 1.4-2.8 2.4-3.9s2.1-2.2 3.3-3.2c.9-.8 1.8-1.5 2.6-2.2.8-.7 1.5-1.4 2.1-2 .6-.7 1-1.4 1.3-2.1.3-.7.4-1.6.2-2.4-.2-1.4-.8-2.4-1.6-2.9s-1.9-.7-3-.5c-1.3.2-2.3.8-3 1.7-.7.9-1 2.3-.7 4.1l-8.1 1.2c-.2-1.6-.2-3.1.1-4.6s1-2.8 1.9-3.9c.9-1.2 2.1-2.2 3.6-3 1.5-.8 3.2-1.4 5.2-1.7 1.6-.2 3.2-.3 4.7-.1 1.5.2 2.9.6 4.1 1.3 1.2.7 2.3 1.7 3.2 2.9.9 1.3 1.4 2.8 1.7 4.7.2 1.5.1 2.9-.3 4.2-.5 1.3-1.1 2.5-1.9 3.6-.8 1.1-1.7 2.1-2.6 2.9s-1.8 1.6-2.6 2.3c-1.1 1-2 1.8-2.7 2.5-.7.7-1.2 1.3-1.6 1.9-.4.6-.6 1.1-.7 1.7-.1.6-.1 1.2 0 1.9l15.1-2.3 1 6.6-24.5 3.7c-.4-2.8-.6-5.2-.4-7.2zm42.7-9.1l-14.1 2.1-3.9-25.5 8.2-1.2 2.8 18.6 5.9-.9-1.5-9.7 8.1-1.2 1.5 9.7 4.3-.7 1 6.9-4.3.7 1.5 9.7-8.1 1.2-1.4-9.7zm13.7-19.8l5.7-.9 1.7 11.1c.4-1.1 1-1.9 2-2.7.9-.7 2.1-1.2 3.6-1.4 1.2-.2 2.3-.2 3.1.1.9.2 1.6.7 2.2 1.3.7.6 1.2 1.4 1.6 2.3.4.9.6 2.1.8 3.4l1.7 11-5.7.9-1.5-9.5c-.2-1.3-.6-2.4-1.2-3.2-.6-.8-1.5-1.1-2.8-.9-1.2.2-2 .7-2.5 1.7-.5.9-.6 2.1-.4 3.6l1.4 9.4-5.7.9-4-27.1z",
  fill: "#4eb7bc"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M152.9 103c-.3-2.2-1.8-4-3.8-4.8 1.3-1.4 2-3.3 1.7-5.3-.5-3.4-3.7-5.8-7.1-5.2l-11 1.7c-2.7.4-5.1-1.8-4.9-4.6.2-2.8-.3-5.6-1.4-8.2-1.1-2.5-2.5-4.7-4.3-6.7-1.7-1.9-4.3-2.6-6.8-1.9-1.8.5-2.7 2.4-2.2 4.2L115 78c.7 2.3.8 4.7.1 7l-3.6 12.7c-.6 2.1-1.9 3.9-3.8 5.1l-2.2 1.4 3.9 25.3.9.6c2.1 1.4 4.5 2.2 7.1 2.5 1.2.1 2.5.1 3.7-.1l22.3-3.4c3.4-.5 5.8-3.7 5.2-7.1-.2-1.1-.7-2.1-1.3-3 2.9-.9 4.7-3.8 4.3-6.9-.2-1.1-.6-2.1-1.3-2.9 1.9-1.3 3-3.7 2.6-6.2z",
  fill: "#e4bc96"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M109.8 138.5l-17 2.6c-1.7.3-3.3-.9-3.5-2.6L84 103.8c-.3-1.7.9-3.3 2.6-3.5l17-2.6c1.7-.3 3.3.9 3.5 2.6l5.3 34.7c.3 1.7-.9 3.3-2.6 3.5",
  fill: "#0e3935"
});

function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 154"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgIconCalendar;